// src/directives/dialogDrag.js
export default {
  bind(el, binding, vnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');

    if (!dialogHeaderEl || !dragDom) return;

    // 设置标题栏可拖拽样式
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // 防止触发其他事件
      e.preventDefault();
      e.stopPropagation();

      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX;
      const disY = e.clientY;

      const screenWidth = document.body.clientWidth;
      const screenHeight = document.body.clientHeight;

      const dragDomWidth = dragDom.offsetWidth;
      const dragDomHeight = dragDom.offsetHeight;

      const minDragDomLeft = dragDom.offsetLeft;
      const minDragDomTop = dragDom.offsetTop;

      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;

      // 获取原有位置
      let styL, styT;

      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      }

      // 边界留白距离
      const BOUNDARY_MARGIN = 10;
      document.onmousemove = function(e) {
        e.preventDefault();
        e.stopPropagation();

        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        // 边界检查（流出10px的位置）
        if (-left > minDragDomLeft - BOUNDARY_MARGIN) {
          left = -minDragDomLeft + BOUNDARY_MARGIN;
        } else if (left > maxDragDomLeft - BOUNDARY_MARGIN) {
          left = maxDragDomLeft - BOUNDARY_MARGIN;
        }

        if (-top > minDragDomTop - BOUNDARY_MARGIN) {
          top = -minDragDomTop + BOUNDARY_MARGIN;
        } else if (top > maxDragDomTop - BOUNDARY_MARGIN) {
          top = maxDragDomTop - BOUNDARY_MARGIN;
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
      };

      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
}
